const constants = {
  app: {
    name: 'Inscrição Chamada Escolar',
  },
  api: {
    currentVersion: '/api/v2',
    address: {
      searchByCityAndTerm: (cityId, term) =>
        `/addresses/search?city_id=${cityId}&q=${encodeURIComponent(term)}`,
      searchByZipcode: zipcode => `/addresses/search_by_zipcode?zipcode=${encodeURIComponent(zipcode)}`,
      states: '/addresses/states',
      cities: id => `/addresses/cities?state_id=${id}`,
    },
    customer: {
      cities: '/customer/cities',
    },
    publicCall: {
      available: '/public_call/available',
      cities: ref => `/public_call/cities?degree_ref=${ref}`,
      curriculums: (degree, school, shift, exceptOfferIds) =>
        `/public_call/curriculums?degree_ref=${degree}&school_ref=${school}&shift=${shift}&except_offer_ids=${exceptOfferIds}`,
      otherCurriculums: (degree, city, exceptOfferIds) =>
        `/public_call/other_curriculums?degree_ref=${degree}&city_ref=${city}&except_offer_ids=${exceptOfferIds}`,
      degrees: '/public_call/degrees',
      info: '/public_call/info',
      questions: '/public_call/questions',
      quizQuestions: '/public_call/quiz_questions',
      schools: (degree, city, exceptOfferIds, zipcode, weakStreetId) =>
        `/public_call/schools?degree_ref=${degree}&city_ref=${city}&except_offer_ids=${exceptOfferIds}&zip_code=${zipcode}${
          weakStreetId ? `&weak_street_id=${weakStreetId}` : ''
        }`,
      schoolsQuestions: '/public_call/schools_questions',
      shifts: (degree, school, exceptOfferIds) =>
        `/public_call/shifts?degree_ref=${degree}&school_ref=${school}&except_offer_ids=${exceptOfferIds}`,
      validateRecaptcha: '/public_call/validate_recaptcha'
    },
    offers: {
      cities: '/offers/cities',
      schools: cityRef =>
        `/offers/schools${cityRef ? `?city_ref=${cityRef}` : ''}`,
      index: (schoolRef, cityRef) => {
        const params = new URLSearchParams()
        params.append('school_ref', schoolRef)
        if (cityRef) params.append('city_ref', cityRef)
        return `/offers?${params.toString()}`
      },
      waitingList: offerId => `/offers/${offerId}/waiting_list`,
    },
    waitingList: {
      insert: (offerId, user_login) =>
        `/waiting_lists/insert?offer_id=${encodeURIComponent(offerId)}&user=${encodeURIComponent(user_login)}`,
      schoolInfo: schoolId => `/waiting_lists/school_info?school_id=${encodeURIComponent(schoolId)}`,
      login: '/waiting_lists/login',
    },
    subscription: {
      get: (cpf, cpfResponsible) =>
        `/subscriptions/search?cpf=${encodeURIComponent(cpf)}&r_cpf=${encodeURIComponent(cpfResponsible)}`,
      create: '/subscriptions/create_async',
      update: uuid => `/subscriptions/${uuid}`,
      pdf: uuid => `/subscriptions/${uuid}/pdf`,
      validate: '/subscriptions/validate',
      getSubscriptionAndEnrollment: (cpf, birthdate) =>
        `/subscriptions/pre_enrollment_check?cpf=${encodeURIComponent(
          cpf
        )}&birthdate=${encodeURIComponent(birthdate)}`,
      verifyResponsible: '/subscriptions/verify_responsible',
      job_status: (jid, jobAction) =>
        `/subscriptions/job_status?job_action=${jobAction}${jid ? `&jid=${jid}` : ''
        }`,
      confirmInterest: '/subscriptions/confirm_interest',
      returnToWaitingList: '/subscriptions/return_to_waiting_list',
      returnReceiptPdf: (cpf, cpfResponsible) =>
        `/subscriptions/return_receipt?cpf=${cpf}&r_cpf=${cpfResponsible}`,
    },
    renewEnrollment: {
      cancel: groupStudentId =>
        `/renew_enrollments/cancel?group_student_id=${groupStudentId}`,
      login: '/renew_enrollments/login',
      nextOffers: groupStudentId =>
        `/renew_enrollments/next?group_student_id=${groupStudentId}`,
      pdf: (groupStudentId, reenrollmentIntentHistoryId) =>
        `/renew_enrollments/pdf?group_student_id=${encodeURIComponent(groupStudentId)}` +
        (reenrollmentIntentHistoryId
          ? `&reenrollment_intentHistory_id=${encodeURIComponent(reenrollmentIntentHistoryId)}`
          : ''),
      create: '/renew_enrollments',
      checkEligibility: groupStudentId =>
        `/renew_enrollments/check_eligibility?group_student_id=${groupStudentId}`,
      search: cpf => `/renew_enrollments/search?cpf=${encodeURIComponent(cpf)}`,
      job_status: (groupStudentId, jid, jobAction) =>
        `/renew_enrollments/job_status?group_student_id=${groupStudentId}&job_action=${jobAction}${jid ? `&jid=${jid}` : ''
        }`,
    },
    subscriptionHistory: {
      get: cpf => `/subscription_histories?cpf=${encodeURIComponent(cpf)}`,
      pdf: id => `/subscription_histories/${id}/pdf`,
    },
    renewEnrollmentHistory: {
      get: group_student_id =>
        `/renew_enrollments/reenrollment_intent_history?group_student_id=${group_student_id}`,
    },
    electricalPowerOperators: {
      index: '/electrical_power_operators',
    },
  },
  params: {
    keys: {
      authUtils: {
        _session: '_scwauth',
      },
    },
    recaptcha: '6LdOyMsoAAAAAEkabHLpw8hNmQAM-2zIV8esKfKy',
    sentry: {
      dsn: 'https://0dcbc7e90ca626feae278542967d0a8e@o7645.ingest.sentry.io/4506310635749376',
    },
  },
  routes: {
    home: {
      key: 'home',
      title: 'Início',
      path: '/',
    },
    instructions: {
      key: 'instructions',
      title: 'Instruções',
      path: '/instrucoes',
    },
    subscriptions: {
      search: {
        key: 'search-subscription',
        title: 'Consultar Inscrição',
        path: '/consultar',
      },
      create: {
        key: 'create-subscription',
        title: 'Nova Inscrição',
        path: '/nova',
      },
      edit: {
        key: 'edit-subscription',
        title: 'Editar Inscrição',
        path: '/editar',
      },
    },
    renewEnrollments: {
      forgotPassword: {
        key: 'renew-enrollment-forgot-password',
        title: 'Esqueci minha senha',
        path: '/rematricula/esqueci-minha-senha',
      },
      request: {
        key: 'renew-enrollment',
        title: 'Solicitar Rematrícula',
        path: '/rematricula',
      },
    },
    preEnrollmentCheck: {
      key: 'pre-enrollment-check',
      title: 'Verificação CPF',
      path: '/pre-matricula-check',
    },
    waitingList: {
      key: 'waiting-list',
      title: 'Lista de espera',
      path: '/lista-de-espera',
      requestInclusion: {
        key: 'request-inclusion',
        title: 'Solicitar Inclusão na Fila de Espera',
        path: '/lista-de-espera/solicitar-inclusao',
      },
    },
  },
  strings: {
    placeholders: {
      error: {
        text: 'Falha ao obter as informações, tente novamente',
        button: 'Tentar novamente',
      },
      loading: {
        text: 'Carregando...',
      },
      notFound: {
        text: 'Desculpe, a página solicitada não pôde ser encontrada...',
        button: 'Ir para página inicial',
      },
    },
    screens: {
      schedules: {
        create: {
          progress: (current, total) => `Etapa ${current} de ${total}`,
        },
      },
      subscriptionHistory: {
        primary: 'Histórico de solicitações',
        secondary: '(pré-matrículas)',
      },
    },
  },
}

export default constants
